import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is Bluetooth app development?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Bluetooth app development refers to creating apps that use Bluetooth technology
                                        to communicate and exchange data with other devices. Bluetooth apps can be used
                                        for many purposes, such as connecting devices to speakers, sharing files between
                                        devices, or enabling location-based services. Bluetooth app development involves
                                        designing and coding the app to connect to and communicate with other
                                        Bluetooth-enabled devices and integrating Bluetooth technology into the app's
                                        functionality.
                                    </p>
                                    <p>
                                        TekRevol offers a range of Bluetooth app development services to help businesses
                                        and
                                        organizations create custom apps that utilize Bluetooth technology.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What services does TekRevol offer in the field of Bluetooth app development?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol offers a range of Bluetooth app development services, including the
                                        design and development of custom Bluetooth apps, integration of Bluetooth
                                        technology into existing apps, and testing and debugging of Bluetooth apps. Our
                                        team of experts can help you understand the potential applications of Bluetooth
                                        technology in your business and develop a customized solution to meet your
                                        specific needs.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;